
export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'PRIVATE_LAND_GET_ITEMS':
      return payload
    case 'PRIVATE_LAND_REMOVE_ITEMS':
      return []
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
